import {
  GET_THEMES_SUCCESS,
  THEMES_LOADING,
  SET_THEME,
  GET_THEME_DETAILS_SUCCESS,
  GET_SCROLL_THEMES_SUCCESS,
} from "./Types";

const INITIAL_STATE = {
  themes: [],
  theme: {},
  meta: {},
  count: 0,
  param: {},
  load: {
    loading: false,
    type: "",
  },
};

export const themesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case THEMES_LOADING:
      return {
        ...state,
        load: {
          loading: action.payload.loading,
          type: action.payload.type,
        },
      };
    case GET_THEMES_SUCCESS:
      return {
        ...state,
        themes: action.payload.data?.themes,
        count: action.payload.extra?.total_count,
      };
    case SET_THEME:
      return {
        ...state,
      };
    case GET_THEME_DETAILS_SUCCESS:
      return {
        ...state,
        theme: action.payload.data?.theme,
      };
    case GET_SCROLL_THEMES_SUCCESS:
      return {
        ...state,
        themes: [...state.themes, ...action.payload.data?.themes],
      };
    default:
      return state;
  }
};
